import { formatGradeValue } from './gradebookTypes';
import { QuestionActionDialog } from './QuestionActionDialog';

interface GiveFullCreditDialogProps {
  errorMessage: string | null;
  isPending: boolean;
  onConfirm(): void;
  onOpenChange(open: boolean): void;
  onRestoreFocus(): void;
  open: boolean;
  points: number;
  questionName: string;
  // The roster's size; 0 when it is not known yet.
  studentCount: number;
  // Students who have not answered the question; null while grades load.
  unansweredCount: number | null;
}

function pointsLabel(points: number) {
  return `${formatGradeValue(points)} of ${formatGradeValue(points)} ${points === 1 ? 'point' : 'points'}`;
}

/** Asks before giving every student on the roster full credit for a question. */
export function GiveFullCreditDialog({
  points,
  questionName,
  studentCount,
  unansweredCount,
  ...dialogProps
}: GiveFullCreditDialogProps) {
  const who =
    studentCount === 0
      ? 'Every student on the roster'
      : studentCount === 1
        ? 'The 1 student on the roster'
        : `All ${studentCount} students`;
  const unanswered =
    unansweredCount && unansweredCount > 0
      ? `, including the ${unansweredCount} who ${unansweredCount === 1 ? 'hasn’t' : 'haven’t'} answered it`
      : '';

  return (
    <QuestionActionDialog
      {...dialogProps}
      confirmLabel="Give full credit"
      pendingLabel="Giving full credit…"
      reassurance="Their answers are kept, and you can still change any student’s score from their gradebook page."
      summary={`${who} will get ${pointsLabel(points)} for this question${unanswered}.`}
      title={`Give everyone full credit for ${questionName}?`}
    />
  );
}
